import { get, download } from 'utils/api';

export const getWarDashboardStats = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return get(`/war-dashboard/stats${query ? '?' + query : ''}`);
};

export const getWarDashboardChargers = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return get(`/war-dashboard/chargers${query ? '?' + query : ''}`);
};

export const getWarDashboardFilters = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return get(`/war-dashboard/filters${query ? '?' + query : ''}`);
};

export const downloadWarDashboardChargers = (params = {}) => {
  return download('/war-dashboard/chargers', { ...params, excel: true });
};

export const warDashboardApi = {
  getWarDashboardStats,
  getWarDashboardChargers,
  getWarDashboardFilters,
  downloadWarDashboardChargers,
};
